<template>
    <FullFillBox
        :pageID="1010"
        :otherPer="[4, 8]"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
        }"
        @otherPermission="(data) => {
            if(data[0].status === 80){
                this.exportButtonCanSpawn = true
            }
            if(data[1].status === 80){
                this.printButtonCanSpawn = true
            }
        }"
    >
        <div class="product-table">
            <h3>{{ $t('product_table') }}</h3>
            <hr>
            <p>{{ $t('product_table_total_product') }}{{ totalProduct }}</p>
            <div class="row">
                <div class="col-4">
                    <p>
                        <span class="float-start">
                            <button class="btn btn-primary"
                                    @click="selectTableRowToggle"
                            >
                                {{ selectButtonText }}
                            </button>
                        </span>
                        <span><button class="btn btn-primary" v-if="exportButtonCanSpawn" @click="exportExcel">{{ $t('common_export_excel') }}</button></span>
                    </p>
                </div>
                <div class="col-4">
                    <button class="btn btn-primary" @click="addNewProduct" v-if="showAddButton">{{ $t('common_add') }}</button>
                </div>
                <div class="col-4">
                    <p>
                        <span>
                            <button class="btn btn-primary"
                                    v-if="printButtonCanSpawn"
                                    @click="togglePopUpPrinterSetting(1)"
                            >
                                {{ $t('product_table_print') }}
                            </button>
                        </span>
                        <span style="margin-left: 10px">{{ $t('common_row_selected') }} {{ selectedRowsNum }}</span>
                    </p>

                </div>
            </div>
            <ProductFilterMultiSelect
                :mainData="mainData"
                ref="filterBar"
                v-if="mainData"
                @getFilteredData="(data) => {
                    this.tabulator.setData(data)
                    this.tabulator.redraw(true)
                }"
            />
            <div ref="tabulatorTableUse"></div>
        </div>
    </FullFillBox>

    <!--   PopupMenu Open Printer Setting List  -->
    <vue-final-modal v-model="showPopUpPrinterSetting" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="togglePopUpPrinterSetting(0)">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <PrinterSetting
                :printData="printDataList"
            />
        </div>
    </vue-final-modal>


    <vue-easy-lightbox
        :visible="showPopUpImageDetails"
        :imgs="thisImageSrc"
        :index="0"
        :zoomScale=1
        @hide="showPopUpImageDetails = false">
    </vue-easy-lightbox>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css'
import VueEasyLightbox from "vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import PrinterSetting from "@/components/PrinterSetting";
import Multiselect from "@vueform/multiselect";
import ProductFilterMultiSelect from "@/components/ProductFilterMultiSelect.vue";

export default {
    name: "ProductTableView",
    components: {
        ProductFilterMultiSelect,
        FullFillBox,
        VueEasyLightbox,
        PrinterSetting,
        Multiselect,
    },
    data(){
        return {
            mainData: [],

            permissionDetails: {},
            showAddButton: false,
            showEditButton: false,
            printButtonCanSpawn: false,
            exportButtonCanSpawn: false,
            totalProduct: '',

            showPopUpImageDetails: false,
            thisImageSrc: '',

            // Printing Stuff
            showPopUpPrinterSetting: false,
            selectAllFlag: false,
            selectButtonText: '',
            selectedRowsNum: 0,
            printDataList: [],
        }
    },
    methods: {
        addNewProduct(){
            this.$router.push(`/product/add`)
        },
        async exportExcel(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/product/export/')
                .then(response => {
                    if(response.data.status === 80){
                        location.href = (this.$store.state.serverIp + response.data.details)
                    }else{
                        console.log(response.data)
                        this.$toast.warning(this.$t('error_excel_export'))
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async getBackendData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/product/list/')
                .then(response => {
                    if(response.data.status === 80){
                        this.tabulator.setData(response.data.details)
                        this.mainData = response.data.details
                        this.totalProduct = response.data.details.length
                    }
                })
            this.$store.commit('setIsTopLoading', false)

        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        selectTableRowToggle(){
            if(this.selectAllFlag === false){
                // Need to Select All
                this.selectButtonText = this.$t('common_row_unselect_all')
                this.tabulator.selectRow()
            }else{
                // Need to Unselect All
                this.selectButtonText = this.$t('common_row_select_all')
                this.tabulator.deselectRow()
            }
            this.selectAllFlag = !this.selectAllFlag
        },
        togglePopUpPrinterSetting(flag){
            if(flag === 0){
                // Need to Close
                this.showPopUpPrinterSetting = false
                this.$store.commit('setIsBlackLayout', false)
            }else{
                // Need to Pop up
                this.showPopUpPrinterSetting = true
                this.$store.commit('setIsBlackLayout', true)
                this.printDataList = this.tabulator.getSelectedData().map(a => a.outCode);
            }
        }
    },
    async mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('product_table')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter:"rownum", resizable: false, sorter: 'number', width: 10,  responsive: 0,},
                {title: 'image', formatter:"image", headerHozAlign:"center", hozAlign:"left", resizable:false, field: 'image_url',
                    width: 60, responsive: 1, headerSort:false, headerMenu: this.getHeaderMenu,
                    formatterParams:{
                        height:"70px",
                        width:"50px",
                        urlPrefix: this.$store.state.serverIp + this.$store.state.serverMediaPath,
                        urlSuffix: "?" + new Date().getTime(),
                    },
                    cellClick: (e, cell) => {
                        this.showPopUpImageDetails = true
                        this.thisImageSrc = this.$store.state.serverIp + this.$store.state.serverMediaPath + cell.getRow().getData().image_url + "?" + new Date().getTime()
                    }
                },
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, width: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, width: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_category'), field: 'category_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, minWidth: 100,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_brand'), field: 'brand_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_name'), field: this.$store.state.language === 'en' ? 'name_en' : 'name_zh',
                    sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 4,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'size', field: 'size_group', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Size Detail', field: 'size_detail', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'Size Remarks', field: 'size_remarks', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_color'), field: 'color', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: 'material', field: 'material', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 2, visible: false,
                    headerFilter: "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_pack', field: 'in_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_unit1', field: 'in_unit1', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_unit2', field: 'in_unit2', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_unit1', field: 'out_unit1', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_unit2', field: 'out_unit2', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'min_stock', field: 'min_stock', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: this.$t('table_outer_packing'), field: 'out_pack', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_length', field: 'in_size_length', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_width', field: 'in_size_width', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'in_size_height', field: 'in_size_height', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_length', field: 'out_size_length', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_width', field: 'out_size_width', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'out_size_height', field: 'out_size_height', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'net_weight', field: 'net_weight', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'gross_weight', field: 'gross_weight', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"input",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {title: 'flag', field: 'flag', sorter: 'string', resizable:false,
                    responsive:1, widthGrow: 2, visible: false,
                    headerFilter:"list",
                    headerFilterParams:{
                        valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                    },
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-pencil-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        if(this.showEditButton){
                            this.$router.push(`/product/${row.getData().outCode}`)
                        }else{
                            this.$toast.error(this.$t('error_no_permission'))
                        }
                   }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            selectable:true,
            selectableRangeMode:"click",
            initialSort: [
                {column: "outCode", dir: "asc"},
                {column: "flag", dir: "desc"},
            ],
            rowFormatter: (row, e) => {
                if(row.getData().flag === false || row.getData().flag === 0){
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })

        this.tabulator.on('rowSelectionChanged', (data, rows) => {
            this.selectedRowsNum = rows.length
        })
        await this.getBackendData()
        this.selectButtonText = this.$t('common_row_select_all')
    }
}
</script>

<style scoped>

</style>
